import React from "react";
import { useLocation } from "react-router-dom";
import styles from "../styles/Footer.module.css";

export default function Footer() {
  const location = useLocation();
  const currentUrl = `https://mychinesehoroscope.com${location.pathname}`;

  // Handle Facebook sharing
  const handleFacebookShare = (e) => {
    e.preventDefault();
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
    window.open(facebookShareUrl, "_blank", "width=600,height=400");
  };

  return (
    <footer>
      {/*
      <hr />
      <h3 className={styles.socialIconsTitle}>Share with friends</h3>
      <p className={styles.socialIcons}>
        {/* Facebook Share Button */}
        {/*
        <a href="#" onClick={handleFacebookShare} title="Share on Facebook">
          <img
            src="/social/facebook.svg"
            alt="My Chinese Horoscope FB"
            title="Share on Facebook"
            width={120}
            height={120}
            loading="lazy"
            style={{ display: "inline-block" }}
          />
        </a>
        */}

        {/* Instagram Link */}
        {/*
        <a
          href="https://www.instagram.com/chinesehoroscope"
          title="Chinese Horoscope Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/social/instagram.svg"
            alt="Chinese Horoscope Instagram"
            title="Chinese Horoscope Instagram"
            width={120}
            height={120}
            loading="lazy"
            style={{ display: "inline-block" }}
          />
        </a>
        */}

        {/* Twitter (X) Button - Uncomment if needed */}
        {/*
        <a
          href="https://x.com/mychinesezodiac"
          title="My Chinese Horoscope Zodiac Finder"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/social/x.svg"
            alt="My Chinese Horoscope Zodiac Finder"
            title="My Chinese Horoscope Zodiac Finder"
            width={120}
            height={120}
            loading="lazy"
            style={{ display: "inline-block" }}
          />
        </a>
        */}
      {/* </p> */}


      <div className={styles.footer}>
        <section className={styles.copy}>
         <div className={styles.link}> <a href="/aboutus">About us</a> | <a href="/directory">Community Directory</a> | <a href="/privacy-policy">Privacy Policy</a> | <a href="/contact">Contact us</a>.</div>
        Copyright MyChineseHoroscope.com &copy; My Chinese Horoscope Zodiac Finder 2026.{" "}
          
          <div className={styles.copycredit}>
            Produced by{" "}
            <a href="https://d24.me" title="D24 Media">
              D24 Media
            </a>{" "}
            |{" "}
            <a href="https://www.pyfsc.com" title="Feng Shui Master">
              Feng Shui Master
            </a>{" "}
            Mr Philip Yuen
          </div>
        </section>
      </div>
    </footer>
  );
}
